module.exports = __webpack_public_path__ + "static/img/background.edc0655.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/background.jpg
// module id = ZIRA
// module chunks = 1